import * as actions from '../utils/Constants';

import { apiRequest, apiGet, apiDeleteWithBodyAndThen, Methods } from '../utils/Api';
import { getCounties, getCities } from '../actions/StaticData';
const apiJurisdictions = `${process.env.REACT_APP_API_HOST}api/Jurisdictions/`;
const apiJurisdiction = `${process.env.REACT_APP_API_HOST}api/Jurisdiction/`;



export const newJurisdiction = () => ({ type: actions.NEW_JURISDICTION })

export const getJurisdictions = () => {
    return {
        type: actions.GET_JURISDICTIONS,
        payload: fetch(apiJurisdictions, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getJurisdiction = (id) => {
    return dispatch => dispatch({
        type: actions.GET_JURISDICTION,
        payload: apiRequest(`${apiJurisdiction}${id}`, Methods.get, null, dispatch).then((res) => {
            const { stateId, countyId } = res;
            dispatch(getCounties(stateId));
            dispatch(getCities(countyId));
            return res;
        })
    });
}

export const deleteJurisdictions = (ids = []) => ({
    type: actions.DELETE_JURISDICTION,
    payload: apiDeleteWithBodyAndThen(apiJurisdictions, ids, () => apiGet(apiJurisdictions))
});

export const toggleJurisdictionIsActive = (id) => {
    return {
        type: actions.TOGGLE_JURISDICTION_ISACTIVE,
        payload: id
    }
}